import Styles from './Controls.module.scss'

import { useImageMenuContext } from '../ImageMenuContext'
import { AI, LinkAngled, Upload } from 'blaze-ui/icons'
import { Giphy } from './icons/Giphy'
import { FileTrigger } from 'components/FileTrigger/FileTrigger'
import { useUploadMedia } from '../useUploadMedia'
import { SearchBar } from './SearchBar/SearchBar'
import { Chip } from 'components/Chip/Chip'

const UploadPill = () => {
  const { maxCount, onUse, onUploadStart, onUploadEnd, accept, setIsConfirming, onUploadProgress, createParams } =
    useImageMenuContext()

  const { uploadFilesFromDevice } = useUploadMedia({
    onUse,
    onUploadStart,
    onUploadEnd,
    setIsConfirming,
    onUploadProgress,
    createParams,
  })

  return (
    <FileTrigger onSelect={uploadFilesFromDevice} accept={accept} allowsMultiple={maxCount > 1}>
      <Chip variant="flat" icon={<Upload />} className={Styles.chip} selectable={false} deletable={false}>
        Upload
      </Chip>
    </FileTrigger>
  )
}

const ShortcutPills = () => {
  const { setProvider, hiddenProviders } = useImageMenuContext()

  const showUploads = !hiddenProviders.includes('device')
  const showAiGeneration = !hiddenProviders.includes('ai')
  const showGifs = !hiddenProviders.includes('gifs')
  const showLink = !hiddenProviders.includes('link')

  return (
    <div className={Styles.shortcutPills}>
      {showUploads && <UploadPill />}
      {showAiGeneration && (
        <Chip variant="flat" icon={<AI />} onPress={() => setProvider('ai')} className={Styles.chip}>
          Generate with AI
        </Chip>
      )}
      {showLink && (
        <Chip variant="flat" icon={<LinkAngled />} onPress={() => setProvider('link')} className={Styles.chip}>
          Add from Link
        </Chip>
      )}
      {showGifs && (
        <Chip variant="flat" icon={<Giphy />} onPress={() => setProvider('gifs')} className={Styles.chip}>
          GIFs
        </Chip>
      )}
    </div>
  )
}

type ControlsProps = {
  showSearchBar?: boolean
}

export const Controls = ({ showSearchBar = false }: ControlsProps) => {
  return (
    <div className={Styles.container}>
      {showSearchBar && <SearchBar />}
      <ShortcutPills />
    </div>
  )
}
